import * as React from 'react';
import { DEFAULT_DATE_FORMAT } from '../utils/constants';
import { DateCalculator, DateValidator } from '../utils/dateUtils';
import dateGenerateConfig from '../utils/momentGenerator';
var CalendarPickerContext = /*#__PURE__*/React.createContext({
  dateValidator: new DateValidator("", function () {}, "", "", 'month'),
  hasInputError: false,
  momentUtils: dateGenerateConfig("", ""),
  dateCalculator: new DateCalculator("", function () {}, "", "", 'month'),
  showPanel: false,
  uuid: "",
  format: DEFAULT_DATE_FORMAT
});
export default CalendarPickerContext;